import ExportButton from 'components/ExportButton/ExportButton.js'
import Top10InstTable from 'modules/Reports/Partials/Institutes/Partials/Top10InstituteTable/Top10ListInstTable/index'

import { filterData } from 'modules/Reports/Components/CommonFunction/CommonFunctionIndex'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import WarningMessage from 'utils/WarningMessage'
import {
  setCityList,
  setTierList,
  setTopInstituteList,
  setUniversityList,
} from '../InstEmpanelledTable/actions'
import { PaddedDiv, SectionWrapper, TopHeader, TopHeading } from './Style/style'

const Top10InstituteInfoTable = ({
  getTopInstituteReport,
  getUniversityList,
  getCityList,
  getTierList,
  instituteListDataForReport,
  universityList,
  cityList,
  tierList,
  excelDataForReport,
  userData,
}) => {
  const dispatch = useDispatch()
  const [sortBy, setSortBy] = useState('')
  const [loadingUniversity, setLoadingUniversity] = useState(false)
  const [filterDatas, setFilterData] = useState({})
  const [keySector, setKeySector] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState(() => searchValue)
  const [stateCount, setStateCount] = useState(0)
  const [stateData, setStateData] = useState([])
  const [cityCount, setCityCount] = useState(0)
  const [cityPage, setCityPage] = useState(0)
  const [cityData, setCityData] = useState([])
  const [statePage, setStatePage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadingTopInst, setLoadingTopInst] = useState(false)
  const [sectorValue, setSectorValue] = useState([])
  const [stateValue, setStateValue] = useState([])
  const [cityValue, setCityValue] = useState([])
  const [industryValue, setIndustryValue] = useState([])
  const [keyState, setKeyState] = useState('')
  const [keyCity, setKeyCity] = useState('')
  const [keyIndustry, setKeyIndustry] = useState('')
  const [createdAtStart, setCreatedAtStart] = useState('')
  const [createdAtEnd, setCreatedAtEnd] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [debounced, setDebounced] = useState(() => keySector)
  const [debouncedIndustry, setDebouncedIndustry] = useState(() => keyIndustry)
  const [debouncedCity, setDebouncedCity] = useState(() => keyCity)
  const [tooltip, setToolTip] = useState(false)

  function hasData(obj) {
    for (let key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return true
      }
    }
    return false
  }

  useEffect(() => {
    dispatch(setTopInstituteList())
    if (hasData(filterDatas)) {
      if (currentPage) {
        if (hasData(filterDatas)) {
          getTopInstituteReport({
            pageSize: 10,
            pageNumber: currentPage - 1,
            setLoadingTopInst,
            searchValue,
            filterDatas,
            sortBy,
          })
        }
      }
    }
  }, [currentPage])

  useEffect(() => {
    dispatch(setTopInstituteList())
    if (hasData(filterDatas)) {
      getTopInstituteReport({
        pageSize: 10,
        pageNumber: 0,
        setLoadingTopInst,
        searchValue,
        filterDatas,
        sortBy,
      })
      setCurrentPage(1)
    }
  }, [debouncedSearch, filterDatas, sortBy])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(keySector)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keySector])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedCity(keyCity)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keyCity])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedIndustry(keyIndustry)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keyIndustry])

  useEffect(() => {
    dispatch(setUniversityList([]))
    let flag = 'TI'
    setStatePage(0)
    let setLoading = setLoadingUniversity
    getUniversityList({ setLoading, keySector, flag })
  }, [debounced])

  useEffect(() => {
    dispatch(setCityList([]))
    let flag = 'TI'
    setCityPage(0)
    getCityList({ setLoading, keyCity, flag })
  }, [debouncedCity])

  useEffect(() => {
    dispatch(setTierList([]))
    let flag = 'TI'
    getTierList({ setLoading, keyIndustry, flag })
  }, [debouncedIndustry])
  const title = [
    { title: 'ID' },
    {
      title: 'Institute Name',
    },
    { title: 'University', width: { wch: 40 }, padding: { ppx: 100 } },
    { title: 'Tier', width: { wch: 30 } },
    { title: 'No of candidates Applied', width: { wch: 45 } },
    { title: 'No of candidates Hired', width: { wch: 20 } },
    { title: 'City', width: { wch: 20 } },
  ]

  const tableData = excelDataForReport?.result?.map(item => [
    { value: item.prefix_id ? item.prefix_id : '-' },
    {
      value: item.campus_name ? item.campus_name : '-',
    },
    { value: item.university ? item.university : '-' },
    { value: item.tier?.toString() ? item.tier : '-' },
    { value: item.studentApplied ? item.studentApplied : '-' },
    { value: item.studentOffered ? item.studentOffered : '-' },
    { value: item.city ? item.city : '-' },
  ])
  const excelData = [{ columns: title, data: tableData }]
  const [isExcel, setIsExcel] = useState('')
  const [excel, setExcel] = useState([])
  const clickedExcel = data => {
    let excel = true
    getTopInstituteReport({
      pageSize: 5000,
      pageNumber: 0,
      setLoading,
      searchValue,
      filterDatas,
      sortBy,
      excel,
    })
    setIsExcel(data)
  }
  useEffect(() => {
    if (
      (excelDataForReport?.result && tableData && isExcel == 'excel') ||
      (excelDataForReport?.result && tableData && isExcel == 'pdf')
    ) {
      if (loadingTopInst) {
        setExcel([])
      } else {
        setExcel(excelData)
      }
    }
  }, [excelDataForReport?.result, loadingTopInst])
  const handleHover = () => {
    if (instituteListDataForReport?.count > 5000) {
      WarningMessage(
        'Note : The Institute count should not exceed 5,000 for data export.  Apply filters if necessary'
      )
    }
  }
  const loadMoreStateData = async () => {
    let flag = 'TI'
    let page = universityList?.page + 1
    let setLoading = setLoadingUniversity
    getUniversityList({ setLoading, keyState, flag, page })

    setStatePage(statePage + 1)
  }
  const loadMoreCityData = async () => {
    let flag = 'TI'
    let page = cityList?.page + 1
    getCityList({ setLoading, keyCity, flag, page })

    setCityPage(cityPage + 1)
  }

  useEffect(() => {
    if (universityList) {
      setStateCount(universityList?.count)
      let data = filterData(universityList?.result, 'university')
      setStateData(data)
    }
    if (cityList) {
      setCityCount(cityList?.count)
      let data = filterData(cityList?.result, 'city')
      setCityData(data)
    }
  }, [universityList, cityList])

  const columnWidths = [17, 64, 60, 22, 50, 45, 28] // Array of column widths

  const HAlign = [
    'center',
    'left',
    'left',
    'center',
    'center',
    'center',
    'left',
    'left',
    'center',
  ]

  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Top 10 institutes</TopHeading>
          <TopHeading flexEnd style={{ display: 'flex', gap: 10 }}>
            <div role="button" tabIndex="0" onMouseEnter={handleHover}>
              <ExportButton
                dataset={excel}
                title={'Top 10 institutes'}
                loading={loading}
                clickedExcel={clickedExcel}
                data={isExcel}
                setIsExcel={setIsExcel}
                count={instituteListDataForReport?.count || 0}
                columnWidth={columnWidths} // Array of column widths
                columnFontSize={10} // Font size for the column data
                horizontalAlignment={HAlign}
                userData={userData}
              />
            </div>
          </TopHeading>
        </TopHeader>
      </PaddedDiv>

      <Top10InstTable
        setLoadingUniversity={setLoadingUniversity}
        loadingUniversity={loadingUniversity}
        industryList={stateData}
        cityList={cityData}
        cityCount={cityCount}
        cityPage={cityPage}
        stateCount={stateCount}
        statePage={statePage}
        loadMoreStateData={loadMoreStateData}
        loadMoreCityData={loadMoreCityData}
        loadingTopInst={loadingTopInst}
        hasProp={hasData(filterDatas)}
        setToolTip={setToolTip}
        tooltip={tooltip}
        tableData={instituteListDataForReport}
        loading={loading}
        isEmpanelled={false}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        setSortBy={setSortBy}
        currentCount={
          10 * currentPage + instituteListDataForReport?.result?.length
        }
        setPageNum={currentPage}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        open={open}
        sectorValue={sectorValue}
        setSectorValue={setSectorValue}
        setFilterData={setFilterData}
        filterData={filterDatas}
        isReport={true}
        sectorList={filterData(tierList?.result, 'tier')}
        industryValue={industryValue}
        setIndustryValue={setIndustryValue}
        cityValue={cityValue}
        stateValue={stateValue}
        setCityValue={setCityValue}
        setStateValue={setStateValue}
        setKeySector={setKeySector}
        keySector={keySector}
        setKeyCity={setKeyCity}
        setKeyIndustry={setKeyIndustry}
        setKeyState={setKeyState}
        keyState={keyState}
        keyIndustry={keyIndustry}
        keyCity={keyCity}
        createdAtStart={createdAtStart}
        createdAtEnd={createdAtEnd}
        setCreatedAtStart={setCreatedAtStart}
        setCreatedAtEnd={setCreatedAtEnd}
        getUniversityList={getUniversityList}
        setLoading={setLoading}
        getCityList={getCityList}
        getTierList={getTierList}
      />
    </SectionWrapper>
  )
}
export default Top10InstituteInfoTable
